import React from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import { ProductList, Title, Submenu } from '../../components'
import { greenRectangleStyle } from '../../rectangleStyles'
import { oprema } from '../../productInfo'

const OpremaPage = () => (
  <PageTransition>
    <div className="products-title-container">
      <div className="container">
        <Title rectangleStyle={greenRectangleStyle}>Oprema</Title>
      </div>
    </div>
    <div className="products-accordion">
      <ProductList products={oprema} />
    </div>
  </PageTransition>
)

export default OpremaPage



// WEBPACK FOOTER //
// ./src/pages/proizvodi/oprema.js